var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    attrs: { type: "url" },
    domProps: { value: _vm.viewValue },
    on: { input: _vm.onInput, focus: _vm.onFocus, blur: _vm.onBlur },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }